import { useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import { useState } from 'react'
import { nextPage } from 'components/RCPro/helpers/nav'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import style from './Frequency.module.scss'

const RCProEstimate = () => {
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const [ nextPageTransition ] = useOutletContext()
  const [ annual, setAnnual ] = useState(!state?.annual)
  const { frequency, layout: { next } } = state.texts
  const price = 15

  const getPrice = () => {
    return annual
      ? price * 12 + '€/an'
      : price + '€/mois'
  }

  const onSubmit = (e) => {
    e.preventDefault()
    nextPage({ pathname, state, navigate, data: { annual } })
    nextPageTransition()
  }

  return (
    <>
      <h1>{frequency.title}</h1>
      <div className={style.infos}>
        <span className={style.price}>{getPrice()} TTC</span>
        {frequency.firstDate}
      </div>

      <form onSubmit={onSubmit}>
        <ul className={style.toggle} onClick={() => setAnnual(!annual)}>
          <li className={annual ? style.selected : undefined}>
            {frequency.yearly}
          </li>
          <li className={!annual ? style.selected : undefined}>
            {frequency.monthly}
          </li>
        </ul>

        <Button
          label={<>{next} <Arrow /></>}
          onClick={onSubmit}
          type="primary"
        />
      </form>
    </>
  )
}

export default RCProEstimate